var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',{staticClass:"mt-10 primary--text text-center"},[_vm._v("Lo sentimos, no tienes los permisos necesarios para visualizar esta página.")])])
}]

export { render, staticRenderFns }